var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-center text-center"},[_c('p',{attrs:{"id":"svg-sad"}},[_c('SadSvg')],1),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":function($event){return _vm.$store.dispatch('application/close')}}},[_vm._v(_vm._s(_vm.buttonText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }